const reloadClass = {
  oldToNewurl: mainLocation => {
    let newLocation = mainLocation;
    // sorting
    if (newLocation.includes('order')) {
      newLocation = newLocation.replace('order', 'sort');
    }
    if (newLocation.includes('created_at')) {
      newLocation = newLocation.replace('created_at', 'created');
    }
    if (newLocation.includes('bestsellers')) {
      newLocation = newLocation.replace('bestsellers', 'best_sellers');
    }
    if (newLocation.includes('most_viewed')) {
      newLocation = newLocation.replace('most_viewed', 'popular');
    }
    if (newLocation.includes('=price')) {
      newLocation = newLocation.replace('=price', '=low_price');
    }
    // filters
    if (newLocation.includes('c2c_frametype')) {
      newLocation = newLocation.replace('c2c_frametype', 'frametype_id');
    }
    if (newLocation.includes('c2c_frame_size')) {
      newLocation = newLocation.replace('c2c_frame_size', 'frame_size_id');
    }
    if (newLocation.includes('c2c_frame_shape')) {
      newLocation = newLocation.replace('c2c_frame_shape', 'frame_shape_id');
    }
    if (newLocation.includes('frame_colour')) {
      newLocation = newLocation.replace('frame_colour', 'frame_color_id');
    }
    if (newLocation.includes('c2c_material')) {
      newLocation = newLocation.replace('c2c_material', 'material_id');
    }
    if (newLocation.includes('c2c_prescription_type')) {
      newLocation = newLocation.replace('c2c_prescription_type', 'prescription_type_id');
    }
    if (newLocation.includes('c2c_gender')) {
      newLocation = newLocation.replace('c2c_gender', 'gender_id');
    }
    if (newLocation.includes('sub_brand')) {
      newLocation = newLocation.replace('sub_brand', 'sub_brand_id');
    }
    if (newLocation.includes('weight_frame')) {
      newLocation = newLocation.replace('weight_frame', 'frame_weight_group_id');
    }
    if (newLocation.includes('c2c_brandname')) {
      newLocation = newLocation.replace('c2c_brandname', 'brandname_id');
    }
    return newLocation;
  },
  reloadData: (paramLocation, categoryActions, locn) => {
    let mainLocation = paramLocation;
    if (mainLocation.length) {
      mainLocation = reloadClass.oldToNewurl(mainLocation);
      if (mainLocation.includes('&oos_searchable=Yes')) {
        mainLocation = mainLocation.replace('&oos_searchable=Yes', '');
      }
      if (mainLocation.includes('oos_searchable=Yes&gan_data')) {
        mainLocation = mainLocation.replace('oos_searchable=Yes', '');
      }
      if (mainLocation.includes('oos_searchable=Yes&dir')) {
        mainLocation = mainLocation.replace('oos_searchable=Yes&', '');
      }
      if (mainLocation.includes('oos_searchable=Yes')) {
        mainLocation = mainLocation.replace('oos_searchable=Yes&', '');
      }
      let location = '';
      if (mainLocation.includes('#')) {
        location = mainLocation.split('#')[1];
      } else {
        location = mainLocation;
      }
      let loc = '';
      if (location.includes('&gan_data=true') && !location.includes('dir')) {
        let temp = '';
        loc = location.slice(location.lastIndexOf('gan') - 1, location.lastIndexOf('true') + 4);
        location.split(loc).forEach(value => {
          temp += value;
        });
        location = temp;
        if (location.length === 0 && loc.length) {
          loc = '';
        }
      }
      if (location.includes('dir') && location.includes('&gan_data=true')) {
        loc = location.slice(location.lastIndexOf('dir'), location.lastIndexOf('true') + 4);
        if (loc.length > 30 && loc.length < 45) {
          let temp = '';
          loc = location.slice(location.lastIndexOf('gan') - 1, location.lastIndexOf('true') + 4);
          location.split(loc).forEach(value => {
            temp += value;
          });
          location = temp;
        } else {
          loc = '';
          let temp = '';
          let ole = '';
          let hole = '';
          ole += location.split('sort')[0];
          hole = `${location.split('sort')[1]}`;
          ole += `sort${hole.split('&')[0]}`;
          hole = location.split(ole)[1];
          hole = hole.split('&gan_data=true')[0];
          ole += '&gan_data=true';
          hole.split('&').forEach(value => {
            if (value.length) {
              if (temp.length) {
                temp += `&${value}`;
              } else {
                temp += value;
              }
            }
          });
          location = temp;
          if (location.length) {
            loc = `&${ole}`;
          } else if (location.length === 0) {
            loc = `?${ole}`;
          }
        }
      }
      let tempString = '';
      if (location.length > 2) {
        if (location.includes('dir')) {
          loc = location.substring(location.lastIndexOf('dir')) + loc;
          location = location.replace(
            location.substring(location.lastIndexOf('dir') - 1, location.length),
            ''
          );
          const tempLocation = location.replace(loc, '');
          if (location.length === 0 && tempLocation) {
            loc = `?${loc}`;
          } else if (tempLocation) {
            loc = `&${loc}`;
          }
        }
        if (location.length) {
          const tempLocat = location.split('&');
          tempLocat.forEach((val, index) => {
            if (index < tempLocat.length - 1) {
              tempString = `${tempString}filter_${val}&`;
            } else {
              tempString = `${tempString}filter_${val}${loc}`;
            }
          });
        } else {
          tempString = location + loc;
        }
      } else {
        tempString = location + loc;
      }
      const object = {};
      let urlWithoutHash = '';
      if (location.length > 0 && location !== '#') {
        if (location.includes('#')) {
          urlWithoutHash = location.split('#')[1];
        } else {
          urlWithoutHash = location;
        }
        const splittedUrl = urlWithoutHash.split('&');
        splittedUrl.forEach(data => {
          const sdata = data.split('=');
          object[sdata[0]] = [];
          const sdataValue = sdata[1] ? sdata[1].split(',').map(data => decodeURI(data)) : [];
          sdataValue.forEach(keys => {
            object[sdata[0]].push(keys);
          });
        });
      }
      // history.pushState('', '', '#' + urlWithoutHash + loc);
      let order = '';
      if (mainLocation.includes('sort=')) {
        order = mainLocation.split('sort=')[1].split('&')[0];
      }
      const temp = {};
      temp.location = locn;
      if (urlWithoutHash.length === 0 && loc.length === 0) {
        temp.location.hash = '';
      } else {
        temp.location.hash = `#${urlWithoutHash}${loc}`;
      }
      // temp.FilterDataObj = FilterDataObj;
      temp.order = order;
      temp.reload = {};
      temp.reload.data = object;
      temp.reload.reload = true;
      categoryActions.modifyData(temp);
      // console.log('reload filter js | reload');
      return tempString;
    }
  },
};

export default reloadClass;
